import * as React from "react";
import { useLocation } from "react-router";
import { ReactComponent as Checked } from "../assets/icons/checked.svg";

export default function CustomizedSteppers({ steps = [] }) {
  const location = useLocation().pathname;

  return (
    <div className="flex flex-row space-x-2 mx-auto">
      {steps.map((step) => (
        <Step
          number={step.number}
          key={step.label}
          label={step.label}
          state={step.state}
          location={location}
          line={step.line}
        />
      ))}
    </div>
  );
}

const Step = ({
  number = "1",
  label = "Tus datos",
  state = "complete",
  line = false,
  key,
}) => {
  return (
    <div key={key} className="flex flex-row items-center space-x-2 sm:space-x-0 font-telefonica">
      {state === "complete" ? (
        <div className="flex flex-col space-y-1 text-center items-center content-center">
          <Checked />
          <p className="hidden sm:flex text-xs text-[#424b5a] font-telefonica">
            {label}
          </p>
        </div>
      ) : (
        <div className="flex flex-col space-y-1 text-center items-center content-center">
          <div
            className={
              "w-7 h-7 rounded-full  text-sm mx-auto " +
              (state === "active"
                ? "border-2 border-primaryTelefonica text-white bg-primaryTelefonica "
                : "border-2 border-fontTelefonica bg-white text-fontTelefonica")
            }
          >
            <div className="mt-0.5 font-telefonicaBold">{number}</div>
          </div>
          <p className="hidden sm:flex text-xs text-[#424b5a] font-telefonica">
            {label}
          </p>
        </div>
      )}

      {line ? <Line /> : <></>}
    </div>
  );
};

const Line = ({ complete = false }) => {
  return (
    <div
      className={`w-7 sm:w-16 h-1 rounded-sm mb-0 sm:mb-4 ${
        complete ? "bg-primaryTelefonica" : "bg-grayTelefonica"
      }`}
    ></div>
  );
};
